module.exports = __webpack_public_path__ + "img/H3.424428eb.png";